export enum EJobWorkItemType {
	IN = "IN",
	OUT = "OUT",
}
